import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-crowdfunding-guide__content _flexcol _gap-6" }
const _hoisted_2 = ["id"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_external_link = _resolveComponent("external-link")
  const _component_localize = _resolveComponent("localize")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, {
    content: true,
    class: "gfu-box--content _tc--base"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.stages, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            key: section.sectionID
          }, [
            _createElementVNode("h3", {
              id: section.sectionID,
              ref_for: true,
              ref: section.sectionID,
              class: "gfu-hd gfu-hd--h3 gfu-heading--top-divider"
            }, _toDisplayString(section.header), 9 /* TEXT, PROPS */, _hoisted_2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.paragraphs, (paragraph) => {
              return (_openBlock(), _createElementBlock("p", {
                key: paragraph.text,
                class: "gfu-bt--b1"
              }, [
                (paragraph.links)
                  ? (_openBlock(), _createBlock(_component_localize, {
                      key: 0,
                      tag: "span",
                      resource: paragraph.text
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paragraph.links, (link, index) => {
                          return (_openBlock(), _createBlock(_component_external_link, {
                            key: `link-${index}`,
                            "format-key": `${index.toString()}`,
                            href: link.url,
                            class: "gfu-link gfu-link--accent _tdu"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(link.text), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["format-key", "href"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(paragraph.text), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}